import type { CSSProperties } from "react";
import { Box } from "@mui/material";

type DotProps = { selected?: boolean; color?: CSSProperties["color"]; size?: "small" | "normal" };

const Dot: React.FC<DotProps> = (props) => {
  const { selected, color = "#e1412f", size = "normal" } = props;

  return (
    <Box
      sx={{
        borderRadius: "100%",
        backgroundColor: color,
        translate: "0 50%",
        ...(size === "normal" && {
          width: 16,
          height: 16,
          border: "1px solid white",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.9)",
        }),
        ...(size === "small" && {
          width: 10,
          height: 10,
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.5)",
        }),
        ...(selected && {
          width: 24,
          height: 24,
          border: "4px solid white",
          boxShadow: "0 1px 5px rgba(0, 0, 0, 0.7)",
        }),
      }}
    />
  );
};

export default Dot;
